import ActionButton from './actionButton';
import { TextField } from "@mui/material";
import Container from '@mui/material/Container';
import { useState, useEffect, useContext } from 'react'
import EventContext from "../store/event-context";
import ColorSelection from './colorSelection';
import TextFieldWithNumpad from "./textFieldWithNumpad";

const ActorInput = ({ lookupActor, isLoading, isDisabled, haveColor }) => {

    const eventctx = useContext(EventContext);
    const [color, setColor] = useState(eventctx.event.colors[0]);
    const [capnr, setCapnr] = useState('');
    const [searching, setSearching] = useState(false);
    const [capNrHasFocus, setCapNrHasFocus] = useState(false);
    //console.log("haveColor: " + haveColor)
    
    // Set the widths of the fields and buttons
    let colorFieldwidth = 106;
    let capnrFieldWidth = '180px';
    let capSearchButtonWidth = '150px';
    if (window.innerWidth < 342) {          // In case of very small screens...
        colorFieldwidth = 96;
        if (haveColor) {
            capnrFieldWidth = '80px';
            capSearchButtonWidth = '110px';
        } else {
            capnrFieldWidth = '165px';
            capSearchButtonWidth = '130px';
        }
    } else if (haveColor) {                 // Normal screen (but probably portrait mode) with Color option
        capnrFieldWidth = '86px';
        capSearchButtonWidth = '140px';
    }

    const searchActor = () => {
        //console.log("searchActor: ", color, capnr);
        //console.log(color)
        //console.log(capnr)
        setSearching(true)
        lookupActor(capnr, color);
    }
      
    const numpadEnter = (value) => {
        //console.log("After numpad - Value: ", value, " - Now query...");
        if (value) {
            setCapnr(value);
            setSearching(true);
            lookupActor(value, color);
        }
    }

    useEffect(() => {
        if (searching && !isLoading) {
            //console.log("useEffect - searching");
            setCapnr("");
            setSearching(false);
        }
        if (capNrHasFocus) {
            //document.getElementById('searchActor').focus();
            document.getElementById('NumpadtextFieldInternal').blur();
            setCapNrHasFocus(false);
        }
    }, 
    [isLoading, searching, capNrHasFocus, capnr])

    return (
        <div>
            <form onSubmit={(e) => {e.preventDefault(); searchActor() }}>
                <Container component='span' id='inputCapNrAndButton' disableGutters sx={{ pl: '6px'}}>
                    {haveColor && <ColorSelection color={color} setColor={setColor} fieldWidth={colorFieldwidth} />}
                    <TextFieldWithNumpad 
                        required
                        id="capnr"
                        disabled={isDisabled}
                        type="number"
                        value={capnr}
                        setValue={setCapnr}
                        onEnter={numpadEnter}
                        toggleFieldFocus={setCapNrHasFocus}
                        label={haveColor? 'Capnr' : 'Capnummer'}
                        sx={{ mr: 1, width: capnrFieldWidth, backgroundColor: 'common.white' }}
                        />
                    <ActionButton
                        id="searchActor"
                        disabled={isDisabled}
                        size="medium"
                        type="submit"
                        color="primary"
                        sx={{ mt: '4px', width: capSearchButtonWidth }} >
                        Opzoeken
                        </ActionButton>
                </Container>
            </form>
        </div>
    )
}

export default ActorInput

